query TravelPolicyAllowances($id: UUID!) {
  travelPolicy(id: $id) {
    id
    _rowTimestamp
    _isUpdatable
    _isDeletable
    description
    currencyId
    companyCurrency {
      id
      isoCode
      name
    }
    isDefaultCustomizable
    isContractual
    isCompanion
    companionTickets
    companionAmount
    isEconomyClassAllowed
    isPremiumClassAllowed
    isBusinessClassAllowed
    isFirstClassAllowed
    isCharterClassAllowed
    travelPolicyAllowancesByTravelPolicyId(orderBy: SORT_ORDER_ASC) {
      nodes {
        id
        _rowTimestamp
        _isUpdatable
        _isDeletable
        country1Id
        country2Id
        country1 {
          country
        }
        country2 {
          country
        }
        stateRegion1Id
        stateRegion2Id
        stateRegion1 {
          stateRegion
        }
        stateRegion2 {
          stateRegion
        }
        expenditureTypeId
        expenditureType {
          expenditureType
        }
        policyAllowance
        policyMiles
        isAllowanceCustomizable
      }
      totalCount
    }
  }
}
